import { contextGlyphs } from "./logo-paths";

// The right side of the logo's context line is the only part an app writes (brand/README.md §3): letters and digits,
// upper case, ten at most. Anything else is left out, so a context cannot break the logo.
const MAX_CHARS = 10;

interface PlacedGlyph {
  d: string;
  x: number;
}

const round = (n: number) => Math.round(n * 100) / 100;

const known = (text: string) =>
  [...text.toUpperCase()].flatMap((char) => contextGlyphs.glyphs[char] ?? []).slice(0, MAX_CHARS);

/** Where each glyph goes so that the ink of the last one ends at `rightEdge`. */
export function contextRight(text: string, rightEdge: number): PlacedGlyph[] {
  const glyphs = known(text);
  const last = glyphs.at(-1);
  if (!last) return [];
  const start = rightEdge - (glyphs.length - 1) * contextGlyphs.step - last.right;
  return glyphs.map(({ d }, i) => ({ d, x: round(start + i * contextGlyphs.step) }));
}

/** How wide a text is from the pen of its first glyph to the ink of its last: the right edge that starts it at 0. */
export function contextWidth(text: string): number {
  const glyphs = known(text);
  const last = glyphs.at(-1);
  return last ? round((glyphs.length - 1) * contextGlyphs.step + last.right) : 0;
}
